import { connect } from "react-redux";

import { requestDailyStatistics, filterDataCompressorsLeistungsaufnahme } from "../model/util/DailyValues";
import SpezifischeLeistungsaufnahmeChart from "./SpezifischeLeistungsaufnahmeChart";

export default connect(state => ({
	model: filterDataCompressorsLeistungsaufnahme(state.charts.daily_values.spezifische_leistungsaufnahme, state.ablauf.compressors),
	timespan: state.charts.daily_values.timespan,
	rtc: state.rtc,
	compressors: state.ablauf.compressors
}), dispatch => ({
	refresh: timespan => {
		requestDailyStatistics("spezifische_leistungsaufnahme",
			timespan.from_ms, timespan.until_ms, dispatch);
	}
}))(SpezifischeLeistungsaufnahmeChart);
